import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconMinusRoundedFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 2.667c7.363 0 13.334 5.969 13.334 13.333S23.364 29.333 16 29.333 2.667 23.364 2.667 16 8.637 2.666 16 2.666M9.778 14.535a1.465 1.465 0 1 0 0 2.931h12.445a1.465 1.465 0 1 0 0-2.931z" /></svg>;
export default SvgIconMinusRoundedFilledSmall;